import { useEffect, useState } from 'react';
import { Header } from './Header';
import { Button, TextField } from '@material-ui/core';
import ApiCall from '../utils/ApiCall';
import { getUsername } from '../utils/cookies';
import { Button as Button2, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Autocomplete } from '@material-ui/lab';

const Voucher = () => {
    const [code, setCode] = useState();
    const [campaignList, setCampaignList] = useState();
    const [selectedCampaign, setSelectedCampaign] = useState();


    const [modal, setModal] = useState(false);
    const toggle = () => {
        setModal(!modal);
        setCode();
    };

    useEffect(() => {
        const data = async () => {
            let response = await ApiCall('agency/GetCampaigns', 'GET', null, true);
            setCampaignList(response?.data?.data);
        }
        data();
    }, []);

    const handleVoucher = async () => {
        const response = await ApiCall('agency/GetCouponCode?discount=' + selectedCampaign?.Id + '&username=' + getUsername(), 'get', null, true);
        setCode(response.data);
        setModal(true);
    }




    return (
        <div className="container">
            <Header />
            <div className="row">
                <div className="col-md-6">
                    {/* <Button variant="contained" onClick={() => handleVoucher(5)} className="w100 fr" style={{ 'textTransform': 'none' }} color="primary">%5 İndirim Kodu</Button> */}
                    <Autocomplete
                        id="searchbox"
                        clearText="Temizle"
                        onChange={(event, value) => setSelectedCampaign(value)}
                        options={campaignList || []}
                        getOptionLabel={(option) => option['Name'] + " ---> " + option['Description']}
                        noOptionsText='Kampanya Bulunamadı'
                        // className="mb10 mt10"
                        style={{ width: '100%', fontSize: 14 }}
                        renderInput={(params) => <TextField {...params} label={"Kampanya"} variant="outlined" />}
                    />
                </div>
                <div className="col-md-6">
                    <Button variant="contained" onClick={handleVoucher} disabled={!selectedCampaign} className="w100 fr h100" style={{ 'textTransform': 'none' }} color="primary">Kod Al</Button>
                </div>
            </div>
            <Modal
                isOpen={modal}
                toggle={toggle}
                centered={true}
                keyboard={false}
                backdrop="static"
                size="sm"
            >
                <ModalHeader toggle={toggle}>
                    <div className="row">
                        <div className="col-md-12">
                            İndirim Kodu
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <h3>
                        {code}
                    </h3>
                </ModalBody>
                <ModalFooter>
                    <Button2 color="secondary" onClick={toggle}>K A P A T</Button2>
                </ModalFooter>
            </Modal>
        </div >
    );
}

export default Voucher;